module.exports = __webpack_public_path__ + "img/biaoti@2x.f5027be6.png";